import React, { useEffect, useState } from "react";
import { BiLinkAlt, BiCopy, BiCheck, BiMenu } from "react-icons/bi";
import "./AffiliateLinkCard.css";
import ClipLoader from "react-spinners/ClipLoader";
import Axios from "axios";
import ReactTooltip from "react-tooltip";
import { SiX } from "react-icons/si";
import {
  BsPerson,
  BsLock,
  BsPen,
  BsTwitterX,
  BsTwitter,
  BsLinkedin,
  BsFacebook,
  BsX,
  BsWhatsapp,
  BsCopy,
} from "react-icons/bs";
import Header from "../../layouts/Header";
import SideNavAff from "../../layouts/SideNavAff";

const AffiliateLinkCard = ({ affiliateCode }) => {
  const [copied, setCopied] = useState(false);
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");
  const [errorDisplay, setErrorDisplay] = useState("none");
  const [details, setDetails] = useState([]);
  const [affiliateid, setAffiliateid] = useState("");
  const [loadBarProgress, setLoadBarProgress] = useState(false);
  const [showSavebtn, setShowSavebtn] = useState(true);
  const [showCliploader, setShowCliploader] = useState(false);
  const [confirmedCopy, setConfirmedCopy] = useState(false);
  const [placeholderText, setPlaceholderText] = useState(true);
  const [affiliateCount, setAffiliateCount] = useState(0);

  const isMobile = window.innerWidth <= 768;
  const [isMob, setIsMob] = useState();
  const [collapsed, setCollapsed] = useState(isMobile);

  //   const affiliateUrl = `https://karamale.com/join?ref=${affiliateCode}`;

  useEffect(() => {
    const partnername = localStorage.getItem("partnername");
    const accounttype = localStorage.getItem("accounttype");
    const partnerid = localStorage.getItem("partnerid");
    document.title = `${partnername} - Affiliate program`;

    const uuid = crypto.randomUUID(); // or use your own UUID logic
    if (!localStorage.getItem("customid")) {
      localStorage.setItem("customid", `${partnerid}${uuid}`);
    }

    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=RECRUITS&subquery=AFFILIATECOUNT&partnerid=${partnerid}`,
      { withCredentials: true }
    ).then((response) => {
      setAffiliateCount(
        response.data.val === 1 ? response.data.affiliateCount : 0
      );
    });

    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=${partnerid}`,
      { withCredentials: true }
    ).then((response) => {
      setAffiliateid(response.data.affiliateid ?? "");
    });

    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);

    return () => {
      // this runs on unmount
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const text =
    "Organizing events? You need to check out #Karamale. Sell tickets, track revenue, and see real-time sales — all in one place.\n\nI'm part of their affiliate program because it works. See for yourself 👉";
  const affiliateUrl = "https://karamale.com?affiliateid=" + affiliateid;
  const shareUrl = `${encodeURIComponent(text)}&url=${encodeURIComponent(
    affiliateUrl
  )}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(affiliateUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768;
    setIsMob(mobile);
    setCollapsed((prev) => (mobile ? true : prev));
  };

  const handleToggle = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <>
      <Header />
      <SideNavAff collapsed={collapsed} onToggle={handleToggle} />
      <div
        className="main-content"
        style={{
          marginTop: 40,
          marginLeft: isMob ? "0px" : collapsed ? "60px" : "240px",
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={handleToggle} />
        )}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="events-dashboard p-3">
          <div className="dashboard-header">
            <h5 className="dashboard-title mt-2">Affiliate Link</h5>
          </div>
          <div className="affiliate-body">
            <div className="row justify-content-center just-container-insid mb-0">
              <div className="col-lg-12 p-0">
                <div className=" BoxDashboardContainer mb-0 pl-1 pr-1">
                  <div className="row align-self-center justify-content-center">
                    {affiliateid !== "" ? (
                      <div className="col-12 pl-1 pr-2 mt-0">
                        <div className="col-12 p-0">
                          <label className="small-details w-100 mb-0">
                            <div className="mb-0 url-holder w-100 align-items-center row">
                              {/* <div className="col-12 p-0 mt-2">
                            <span style={{ color: "#000" }}>
                              Click to copy and share your referral link below
                              to bring new event organizers on board.
                            </span>
                          </div> */}

                              <label className="mt-1 mb-2 text-black">
                                <span>
                                  Your unique affiliate link is shown below.
                                </span>
                              </label>

                              <div className="row align-items-center w-100 cursor-pointer">
                                <div className="col-12 p-0">
                                  <input
                                    type="text"
                                    value={`${affiliateUrl}`}
                                    readOnly
                                    className="affiliate-input"
                                  />
                                  <button
                                    className="copy-btn mt-3 float-right mb-3"
                                    onClick={handleCopy}
                                  >
                                    {copied ? (
                                      <BiCheck size={18} />
                                    ) : (
                                      <BiCopy size={18} />
                                    )}
                                    {copied ? "Copied" : "Copy"}
                                  </button>
                                </div>
                              </div>

                              <div className="col-12 pl-0 pr-0 mt-3">
                                <div className="col-12 p-0 mb-2">
                                  <label className="color-black">
                                    <span>Boost your reach.</span>
                                    <br />
                                    Share your unique affiliate link on your
                                    favorite social platforms to grow your
                                    impact and earn more.
                                  </label>
                                </div>
                                <div className="row w-100 mb-2">
                                  <a
                                    target="_blank"
                                    data-url={"#karamale"}
                                    href={`https://www.facebook.com/sharer/sharer.php?u=https://karamale.com?affiliateid=${affiliateid}`}
                                    data-size="large"
                                  >
                                    <BsFacebook size={25} color="#1877F2" />
                                  </a>
                                  &nbsp;&nbsp;
                                  <a
                                    target="_blank"
                                    data-url={"#karamale"}
                                    href={`https://x.com/share?text=${shareUrl}`}
                                    data-size="large"
                                  >
                                    <SiX size={25} color="#000000" />
                                  </a>
                                  &nbsp;&nbsp;
                                  <a
                                    target="_blank"
                                    href={`https://wa.me/?text=${shareUrl}`}
                                  >
                                    <BsWhatsapp size={25} color="#128c7e" />
                                  </a>
                                  &nbsp;&nbsp;
                                  <a
                                    target="_blank"
                                    href={`https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(
                                      text
                                    )} ${encodeURIComponent(affiliateUrl)}`}
                                  >
                                    <BsLinkedin size={25} color="#0077B5" />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                    ) : (
                      <div className="col-12 pl-1 pr-2 mt-2">
                        <div className="col-12">
                          <label className="small-details w-100">
                            <span>Save this affiliate id</span>
                          </label>
                          <div className="row align-items-center">
                            <div className="col-lg-10 col-8 col-sm-10 col-md-10 p-0">
                              <label className="edit-input mt-0 text-input-bg-color-white small-details pl-0 pr-0">
                                https://karamale.com?affiliateid=
                                {affiliateid}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AffiliateLinkCard;
